import { Injectable, ɵɵdefineInjectable, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { __awaiter } from 'tslib';
import { MenuAuthenticationService } from 'vesta-authentication';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SortablejsModule } from 'angular-sortablejs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaMenuService {
    constructor() {
        this.FavoriteSuject = new Subject();
        this.FavoritesEvent = new Subject();
        this._Favorites = [];
    }
    /**
     * @param {?} favorites
     * @return {?}
     */
    set Favorites(favorites) {
        if (!Array.isArray(favorites))
            favorites = [];
        this._Favorites = favorites;
        this.FavoriteSuject.next(favorites);
    }
    /**
     * @return {?}
     */
    get Favorites() {
        return this._Favorites;
    }
}
VestaMenuService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
VestaMenuService.ctorParameters = () => [];
/** @nocollapse */ VestaMenuService.ngInjectableDef = ɵɵdefineInjectable({ factory: function VestaMenuService_Factory() { return new VestaMenuService(); }, token: VestaMenuService, providedIn: "root" });
if (false) {
    /** @type {?} */
    VestaMenuService.prototype.FavoriteSuject;
    /** @type {?} */
    VestaMenuService.prototype.FavoritesEvent;
    /**
     * @type {?}
     * @private
     */
    VestaMenuService.prototype._Favorites;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.objects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VestaMenuObjects;
(function (VestaMenuObjects) {
    class FavoritesOrder {
        /**
         * @param {?} id
         * @param {?} tittle
         * @param {?} ordenPrioridad
         * @param {?} icon
         * @param {?} count
         * @param {?} routerLink
         * @param {?} isStarFull
         * @return {?}
         */
        static getFavoritesOrder(id, tittle, ordenPrioridad, icon, count, routerLink, isStarFull) {
            /** @type {?} */
            let objectFavoritesOrder = new FavoritesOrder();
            objectFavoritesOrder.Id = id;
            objectFavoritesOrder.Tittle = tittle;
            objectFavoritesOrder.OrdenPrioridad = ordenPrioridad;
            objectFavoritesOrder.Icon = icon;
            objectFavoritesOrder.Count = count;
            objectFavoritesOrder.RouterLink = routerLink;
            objectFavoritesOrder.IsStarFull = isStarFull;
            return objectFavoritesOrder;
        }
        /**
         * @return {?}
         */
        static Mock() {
            return [{ 'id': '1', 'ordenPrioridad': 1 },
                { 'id': '2', 'ordenPrioridad': 3 },
                { 'id': '5', 'ordenPrioridad': 5 },
                { 'id': '8', 'ordenPrioridad': 6 },
                { 'id': '10', 'ordenPrioridad': 2 },
                { 'id': '12', 'ordenPrioridad': 4 },
                { 'id': '15', 'ordenPrioridad': 7 },
                { 'id': '18', 'ordenPrioridad': 9 },
                { 'id': '20', 'ordenPrioridad': 8 },
                { 'id': '23', 'ordenPrioridad': 12 },
                { 'id': '28', 'ordenPrioridad': 10 },
                { 'id': '30', 'ordenPrioridad': 11 }];
        }
    }
    VestaMenuObjects.FavoritesOrder = FavoritesOrder;
    if (false) {
        /** @type {?} */
        FavoritesOrder.prototype.Id;
        /** @type {?} */
        FavoritesOrder.prototype.Tittle;
        /** @type {?} */
        FavoritesOrder.prototype.OrdenPrioridad;
        /** @type {?} */
        FavoritesOrder.prototype.Icon;
        /** @type {?} */
        FavoritesOrder.prototype.Count;
        /** @type {?} */
        FavoritesOrder.prototype.RouterLink;
        /** @type {?} */
        FavoritesOrder.prototype.IsStarFull;
    }
    class ObjetoSubmenu {
        /**
         * @param {?} id
         * @param {?} name
         * @param {?} urlicon
         * @param {?} count
         * @param {?} routerLink
         * @param {?} isStarFull
         * @return {?}
         */
        static getObjetoSubmenu(id, name, urlicon, count, routerLink, isStarFull) {
            /** @type {?} */
            let objectObjetoSubmenu = new ObjetoSubmenu();
            objectObjetoSubmenu.id = id;
            objectObjetoSubmenu.name = name;
            objectObjetoSubmenu.urlicon = urlicon;
            objectObjetoSubmenu.count = count;
            objectObjetoSubmenu.routerLink = routerLink;
            objectObjetoSubmenu.isStarFull = isStarFull;
            return objectObjetoSubmenu;
        }
    }
    VestaMenuObjects.ObjetoSubmenu = ObjetoSubmenu;
    if (false) {
        /** @type {?} */
        ObjetoSubmenu.prototype.id;
        /** @type {?} */
        ObjetoSubmenu.prototype.name;
        /** @type {?} */
        ObjetoSubmenu.prototype.urlicon;
        /** @type {?} */
        ObjetoSubmenu.prototype.count;
        /** @type {?} */
        ObjetoSubmenu.prototype.routerLink;
        /** @type {?} */
        ObjetoSubmenu.prototype.isStarFull;
    }
    class Data {
        /**
         * @param {?} menu
         * @param {?} submenu
         * @return {?}
         */
        static getData(menu, submenu) {
            /** @type {?} */
            let objectData = new Data();
            objectData.menu = menu;
            objectData.submenu = submenu;
            return objectData;
        }
        /**
         * @return {?}
         */
        static Mock() {
            return [
                {
                    menu: 'Aduanas', submenu: [
                        { id: '1', name: 'Cola Trabajo Analista Documentos', urlicon: 'images/transit.png', count: 7, routerLink: '/colatrabajoanalistadocumentos/index', 'isStarFull': 0 },
                        { id: '2', name: 'Principal Gestor Logistico', urlicon: 'images/transit.png', count: 19, routerLink: '/principal/index', 'isStarFull': 0 },
                        { id: '3', name: 'Submenu Aduanas 3', urlicon: 'images/transit.png', count: 4, routerLink: '', 'isStarFull': 0 },
                        { id: '4', name: 'Submenu Aduanas 4', urlicon: 'images/transit.png', count: 3, routerLink: '', 'isStarFull': 0 },
                        { id: '5', name: 'Submenu Aduanas 5', urlicon: 'images/transit.png', count: 2, routerLink: '', 'isStarFull': 0 },
                        { id: '6', name: 'Submenu Aduanas 6', urlicon: 'images/transit.png', count: 6, routerLink: '', 'isStarFull': 0 },
                        { id: '7', name: 'Submenu Aduanas 7', urlicon: 'images/transit.png', count: 7, routerLink: '', 'isStarFull': 0 },
                        { id: '8', name: 'Submenu Aduanas 8', urlicon: 'images/transit.png', count: 9, routerLink: '', 'isStarFull': 0 },
                        { id: '9', name: 'Submenu Aduanas 9', urlicon: 'images/transit.png', count: 11, routerLink: '', 'isStarFull': 0 },
                        { id: '10', name: 'Submenu Aduanas 10', urlicon: 'images/transit.png', count: 3, routerLink: '', 'isStarFull': 0 },
                        { id: '11', name: 'Submenu Aduanas 11', urlicon: 'images/transit.png', count: 1, routerLink: '', 'isStarFull': 0 },
                        { id: '12', name: 'Submenu Aduanas 12', urlicon: 'images/transit.png', count: 6, routerLink: '', 'isStarFull': 0 },
                        { id: '13', name: 'Submenu Aduanas 13', urlicon: 'images/transit.png', count: 0, routerLink: '', 'isStarFull': 0 }
                    ]
                },
                {
                    menu: 'Torre',
                    submenu: [
                        { id: '14', name: 'Submenu Torre 1', urlicon: 'images/transit.png', count: 10, routerLink: '', 'isStarFull': 0 },
                        { id: '15', name: 'Submenu Torre 2', urlicon: 'images/transit.png', count: 20, routerLink: '', 'isStarFull': 0 },
                        { id: '16', name: 'Submenu Torre 3', urlicon: 'images/transit.png', count: 30, routerLink: '', 'isStarFull': 0 },
                        { id: '17', name: 'Submenu Torre 4', urlicon: 'images/transit.png', count: 1, routerLink: '', 'isStarFull': 0 },
                        { id: '18', name: 'Submenu Torre 5', urlicon: 'images/transit.png', count: 7, routerLink: '', 'isStarFull': 0 },
                        { id: '19', name: 'Submenu Torre 6', urlicon: 'images/transit.png', count: 9, routerLink: '', 'isStarFull': 0 },
                        { id: '20', name: 'Submenu Torre 7', urlicon: 'images/transit.png', count: 11, routerLink: '', 'isStarFull': 0 },
                        { id: '21', name: 'Submenu Torre 8', urlicon: 'images/transit.png', count: 23, routerLink: '', 'isStarFull': 0 },
                        { id: '22', name: 'Submenu Torre 9', urlicon: 'images/transit.png', count: 14, routerLink: '', 'isStarFull': 0 }
                    ]
                },
            ];
        }
    }
    VestaMenuObjects.Data = Data;
    if (false) {
        /** @type {?} */
        Data.prototype.menu;
        /** @type {?} */
        Data.prototype.submenu;
    }
})(VestaMenuObjects || (VestaMenuObjects = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaMenuComponent {
    /**
     * @param {?} menu
     * @param {?} menuAuthentication
     */
    constructor(menu, menuAuthentication) {
        this.menu = menu;
        this.menuAuthentication = menuAuthentication;
        this.btnsChangeOrd = false;
        this.data = [];
        this.favoritesOrder = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.GetMenu();
            if (this.menu.Favorites.length > 0) {
                this.favoritesOrder = this.menu.Favorites;
                this.matchFavorites();
            }
            this.menu.FavoriteSuject.subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                this.favoritesOrder = response;
                this.matchFavorites();
            }));
        });
    }
    //async GetMenu() {
    //  this.data = await this.menu.GetMenu();
    //  this.matchFavorites();
    //}
    /**
     * @return {?}
     */
    GetMenu() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let menu = yield this.menuAuthentication.MenuAuthentication;
            /** @type {?} */
            let arrayMenu = [];
            menu.Epics.forEach((/**
             * @param {?} f
             * @return {?}
             */
            f => {
                /** @type {?} */
                let submenu = [];
                f.Features.forEach((/**
                 * @param {?} ff
                 * @return {?}
                 */
                ff => {
                    if (ff.Backlogs.length == 1) {
                        let [backlogs] = ff.Backlogs;
                        /** @type {?} */
                        let obj = { id: backlogs.Id, name: ff.Nombre, urlicon: "", count: 0, routerLink: backlogs.Uri, isStarFull: false };
                        submenu.push(obj);
                    }
                }));
                /** @type {?} */
                let menuItem = VestaMenuObjects.Data.getData(f.Nombre, submenu);
                arrayMenu.push(menuItem);
            }));
            //console.log(arrayMenu);
            this.data = arrayMenu;
        });
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $('.btn-close').click((/**
         * @return {?}
         */
        function () {
            $('#btnFavorites').removeClass('active');
        }));
    }
    //showModalFavorites() {
    //  this.modalFavorites.showModal();
    //}
    //Prueba(id: string) {
    //  console.log("prueba " + id);
    //  let ids = '#' + id;
    //  $(ids).removeClass('mif-star-empty').addClass('mif-star-full');
    //  //this.renderer.removeClass(this.btnFavorite.nativeElement, 'mif-star-empty');
    //  //this.renderer.addClass(this.btnFavorite.nativeElement, 'mif-star-full');
    //}
    /**
     * @return {?}
     */
    matchFavorites() {
        //let listaSubmenu = this.data.map(d => d.submenu).reduce((acc, val) => acc.concat(val), [])
        //  .map(m => VestaMenuObjects.ObjetoSubmenu.getObjetoSubmenu(m.id, m.name, m.urlicon, m.count, m.routerLink, m.isStarFull));//.toArray();
        //let listaSubmenu = [];
        //for (let i = 0; i < submenus.length; i++) {
        //  for (let j = 0; j < submenus[i].length; j++) {
        //    listaSubmenu.push(VestaMenuObjects.ObjetoSubmenu.getObjetoSubmenu(submenus[i][j].id, submenus[i][j].name,
        //      submenus[i][j].urlicon, submenus[i][j].count, submenus[i][j].routerLink, submenus[i][j].isStarFull))
        //  }
        //}
        //Ordenar los favoritos por orden de prioridad
        //this.favoritesOrder = listaSubmenu;
        //listaSubmenu.Enumerable().join(this.favorites, s => s.id, z => z.id,
        //  (x, y) => VestaMenuObjects.FavoritesOrder.getFavoritesOrder(y.id, x.name, y.ordenPrioridad, x.urlicon,
        //    x.count, x.routerLink, x.isStarFull))
        //  .orderBy(o => o.ordenPrioridad).toArray();
        //Actualizar la data, es decir cambiar en la clase del icono 'mif-star-empty' por 'mif-star-full' eso no se harìa aqui, sino que en el template
        for (let i = 0; i < this.favoritesOrder.length; i++) {
            for (let j = 0; j < this.data.length; j++) {
                for (let k = 0; k < this.data[j].submenu.length; k++) {
                    if (this.favoritesOrder[i].Id === this.data[j].submenu[k].id) {
                        this.data[j].submenu[k].isStarFull = true;
                    }
                }
            }
        }
        //No lo borre, quiero ver si se puede hacer de esta forma... Por ahora, no funciona
        //this.data = Enumerable.from(this.favoritesOrder)
        //    .join(submenus, f => f.id, d => d.id,
        //        (x, y) => Data.getData('Prueba', [x.id, x.name, x.urltransit, x.count, x.routerLink, 1])).toArray();
        //this.data2 = Enumerable.from(this.data).select((s,i) =>
        //    Enumerable.from(s[i].submenu).join(this.favoritesOrder, r => s[i].id, f => f.id,
        //        (xsub, yf) => Data.getData(s.menu,
        //            [{ id: s[i].id, name: s[i].name, urltransit: s[i].urltransit, count: s[i].count, routerLink: s[i].routerLink, isStarFull: 1 }]))).toArray();
        //console.log(this.data2);
    }
    /**
     * @param {?} id
     * @param {?} index
     * @return {?}
     */
    getFavorites(id, index) {
        /** @type {?} */
        let favorite = this.favoritesOrder[index];
        this.favoritesOrder.splice(index, 1);
        this.menu.FavoritesEvent.next({ Add: false, Favorite: favorite });
        let [submenu] = this.data.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.submenu.some((/**
         * @param {?} ss
         * @return {?}
         */
        ss => ss.id == id)))).map((/**
         * @param {?} m
         * @return {?}
         */
        m => m.submenu))
            .reduce((/**
         * @param {?} acc
         * @param {?} val
         * @return {?}
         */
        (acc, val) => acc.concat(val)), []).filter((/**
         * @param {?} f
         * @return {?}
         */
        f => f.id == id));
        submenu.isStarFull = false;
    }
    /**
     * @param {?} id
     * @param {?} subMenuIndex
     * @param {?} dataIndex
     * @param {?} boolStar
     * @return {?}
     */
    setFavorites(id, subMenuIndex, dataIndex, boolStar) {
        if (!boolStar) {
            this.SetFavoritesAdd(subMenuIndex, dataIndex);
        }
        else if (boolStar) {
            this.SetFavoritesDeleted(subMenuIndex, dataIndex, id);
        }
    }
    /**
     * @private
     * @param {?} subMenuIndex
     * @param {?} dataIndex
     * @return {?}
     */
    SetFavoritesAdd(subMenuIndex, dataIndex) {
        /** @type {?} */
        let submenu = this.data[dataIndex].submenu[subMenuIndex];
        submenu.isStarFull = true;
        /** @type {?} */
        let favorite = VestaMenuObjects.FavoritesOrder.getFavoritesOrder(submenu.id, submenu.name, this.favoritesOrder.length + 1, submenu.urlicon, submenu.count, submenu.routerLink, true);
        this.favoritesOrder.push(favorite);
        this.menu.FavoritesEvent.next({ Add: true, Favorite: favorite });
    }
    /**
     * @private
     * @param {?} subMenuIndex
     * @param {?} dataIndex
     * @param {?} id
     * @return {?}
     */
    SetFavoritesDeleted(subMenuIndex, dataIndex, id) {
        this.data[dataIndex].submenu[subMenuIndex].isStarFull = false;
        /** @type {?} */
        let index = this.favoritesOrder.Enumerable().indexOf((/**
         * @param {?} i
         * @return {?}
         */
        i => i.Id == id));
        /** @type {?} */
        let favorite = this.favoritesOrder[index];
        this.favoritesOrder.splice(index, 1);
        this.menu.FavoritesEvent.next({ Add: false, Favorite: favorite });
        //this.favoritesOrder = this.favoritesOrder.Enumerable().select((s, i) =>
        //  VestaMenuObjects.FavoritesOrder.getFavoritesOrder(s.id, s.tittle, i + 1, s.icon, s.count, s.routerLink, s.isStarFull)).toArray();
    }
}
VestaMenuComponent.decorators = [
    { type: Component, args: [{
                selector: 'vesta-menu',
                template: "<div class=\"\">\r\n  <div class=\"imagenFondo\">\r\n    <br /><br />\r\n\r\n    <!--Lista de favoritos-->\r\n    <h2 style=\"font-size:24px; margin-top:25px; padding-left:18px; font-weight:600\">Favoritos</h2>\r\n    <div class=\"grid\">\r\n      <div class=\"flex-grid\">\r\n        <div class=\"row flex-wrap\" [sortablejs]=\"favoritesOrder\">\r\n          <div class=\"cell-auto-size\" *ngFor=\"let subitem of favoritesOrder;let i = index\">\r\n            <!---->\r\n            <div class=\"card divOpMenu border bd-grayLight bd-darkAmber-hover fg-darkBlue text-bold bg-white cell\" [routerLink]='[\"/\" + subitem.RouterLink]'>\r\n              <!---->\r\n              <div class=\"card-body\" style=\"cursor: pointer; height:130px;\">\r\n                <button class=\"iconFavorite bg-white border bd-white\" (click)=\"getFavorites(subitem.Id,i)\">\r\n                  <span [attr.id]=\"subitem.Id\" class=\"mif-star-full fg-darkOrange\"></span>\r\n                </button>\r\n                <span class=\"tittleOpMenu text-left\">{{subitem.Tittle}}</span>\r\n                <span class=\"mif-infinite iconOpMenu\"></span>\r\n                <span class=\"countBottom bg-darkOrange fg-white\">{{subitem.Count}}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Submenus-->\r\n    <div class=\"grid\">\r\n      <div class=\"flex-grid\">\r\n        <ng-template ngFor let-j=\"index\" let-item [ngForOf]=\"data\">\r\n          <h2 class=\"cell-auto-size fg-darkGrayBlue\" style=\"font-size:24px; padding-left:18px; font-weight:600\">{{item.menu}}</h2>\r\n          <div class=\"row flex-wrap\">\r\n            <div class=\"cell-auto-size\" *ngFor=\"let subitem of item.submenu; let i=index\">\r\n              <!---->\r\n              <div class=\"card divOpMenu border bd-grayLight bd-dark-grayBlue text-bold bg-white cell\">\r\n                <!---->\r\n                <div class=\"card-body\">\r\n                  <button class=\"iconFavorite bg-white border bd-white\" (click)=\"setFavorites(subitem.id, i, j, subitem.isStarFull)\">\r\n                    <span [attr.id]=\"subitem.id\" class=\"fg-darkOrange\"\r\n                          [ngClass]=\"{\r\n                          'mif-star-empty': !subitem.isStarFull,\r\n                          'mif-star-full': subitem.isStarFull\r\n                          }\">\r\n                    </span>\r\n                  </button>\r\n                  <div [routerLink]='[\"/\" + subitem.routerLink]' style=\"height:130px; width: auto;cursor: pointer;\">\r\n                    <span class=\"tittleOpMenu text-left\">{{subitem.name}}</span>\r\n                    <span class=\"mif-infinite iconOpMenu\"></span>\r\n                    <span class=\"countBottom bg-darkOrange fg-white\">{{subitem.count}}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n",
                styles: [".imagenFondo{background-image:url(data:image/jpeg;base64,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)}.tittleOpMenuFavorite{height:32px;position:absolute;top:26px;font-size:11px;right:9px;line-height:13px;word-break:break-word;padding:3px 1px;width:90%;font-weight:600}.divOpMenu{height:130px;width:130px}.iconOpMenuFavorite{max-width:33%;height:33%;position:absolute;top:75%;left:25%;-webkit-transform:translateY(-50%) translateX(-50%);transform:translateY(-50%) translateX(-50%);font-size:50px;line-height:50px;z-index:2}.multi-action{display:inline-block;position:relative;width:56px;height:56px}.button-position{position:fixed;width:60px;height:60px;bottom:40px;right:40px}.countBottomFavorite{right:10px;bottom:15px;position:absolute;display:block;padding:4px 8px;font-size:12px;text-align:center;z-index:2}.iconFavorite{top:1px;right:10px;position:absolute;display:block;padding:4px 8px;font-size:15px;text-align:center}.ul-Favorites{border:1px solid #dbdbd3;font-size:15px;background-color:#f5f5f2;padding:0;min-height:50px}.li-Favorites{color:#66665d;list-style-type:none;padding:10px;cursor:pointer;border-bottom:1px solid #dbdbd3}.leftButton{bottom:68px;right:10px}.rightButton{bottom:68px;left:37px}.countBottom{right:10px;top:102px;position:absolute;display:block;padding:4px 8px;font-size:12px;text-align:center;z-index:2;border-top-left-radius:3px;border-top-right-radius:3px}.iconOpMenu{max-width:33%;height:33%;left:4%;-webkit-transform:translateY(150%) translateX(10%);transform:translateY(150%) translateX(10%);font-size:50px;line-height:50px;z-index:2}.tittleOpMenu{height:32px;position:absolute;top:26px;font-size:11px;right:9px;line-height:13px;word-break:break-word;padding:3px 1px;width:90%;font-weight:600}.card{border-radius:5px;margin-left:10px;margin-right:10px;z-index:3}.card-header{border-bottom:1px solid #eee;padding:1rem;font-size:16px;border-radius:2px 2px 0 0;display:block}.card-content{display:block}"]
            }] }
];
/** @nocollapse */
VestaMenuComponent.ctorParameters = () => [
    { type: VestaMenuService },
    { type: MenuAuthenticationService }
];
if (false) {
    /** @type {?} */
    VestaMenuComponent.prototype.btnsChangeOrd;
    /** @type {?} */
    VestaMenuComponent.prototype.data;
    /** @type {?} */
    VestaMenuComponent.prototype.favoritesOrder;
    /**
     * @type {?}
     * @private
     */
    VestaMenuComponent.prototype.menu;
    /**
     * @type {?}
     * @private
     */
    VestaMenuComponent.prototype.menuAuthentication;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VestaMenuModule {
}
VestaMenuModule.decorators = [
    { type: NgModule, args: [{
                declarations: [VestaMenuComponent],
                imports: [
                    CommonModule, RouterModule, SortablejsModule //ModalModule
                ],
                exports: [VestaMenuComponent],
                providers: [VestaMenuService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta-menu.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { VestaMenuComponent, VestaMenuModule, VestaMenuObjects, VestaMenuService };
//# sourceMappingURL=vesta-menu.js.map
